import "./settingsLawFirmProfile.css";

import React, { useState } from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RadioButton from "../../../components/input/new/radioButton"; // Assuming you have this component
import TextAreaWithCount from "../../../components/input/new/textAreaWithCount"; // Assuming you have this component
import NarrowInputField from "../../../components/input/new/narrowInputField"; // Assuming you have this component

export default function SettingsLawFirmProfile() {
  const [practiceName, setPracticeName] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [description, setDescription] = useState("");
  const [websites, setWebsites] = useState([""]);
  const [googleBooking, setGoogleBooking] = useState("no");

  const handleLogoChange = (e) => {
    setLogoFile(e.target.files[0]);
  };

  const handleDescriptionChange = (e) => {
    if (e.target.value.length <= 2000) {
      setDescription(e.target.value);
    }
  };

  const handleWebsiteChange = (idx, val) => {
    const next = [...websites];
    next[idx] = val;
    setWebsites(next);
  };

  const addWebsite = () => {
    setWebsites([...websites, ""]);
  };

  const removeWebsite = (idx) => {
    setWebsites(websites.filter((_, i) => i !== idx));
  };

  return (
    <div className="firm-profile-page">
      <h1 className="firm-profile-title">Law firm profile</h1>
      <p className="firm-profile-subtitle">
        Manage your public‑facing profile for your law firm.
      </p>

      {/* Practice Name */}
      <NarrowInputField
        name="Practice Name"
        title="Practice Name"
        placeholder="Enter practice name"
        value={practiceName}
        onChange={(e) => setPracticeName(e.target.value)}
        isRequired={true}
      />

      {/* Logo Upload */}
      <div className="firm-profile-group">
        <label className="firm-profile-label">
          Firm logo <span className="firm-profile-optional">(optional)</span>
        </label>
        <p className="firm-profile-note">
          A clear logo builds credibility and increases appointment bookings.
        </p>
        <input
          id="logo-upload"
          type="file"
          accept="image/*"
          className="firm-profile-file-input"
          onChange={handleLogoChange}
        />
        <label htmlFor="logo-upload" className="firm-profile-btn">
          Upload logo
        </label>
        {logoFile && (
          <span className="firm-profile-filename">{logoFile.name}</span>
        )}
      </div>

      {/* Description */}
      <TextAreaWithCount
        maxChars={2000}
        placeholder="Describe your firm’s areas of practice, legal philosophy, or notable achievements."
        value={description}
        onChange={handleDescriptionChange}
      />

      <div className="firm-profile-divider" />

      {/* Gender Selection using RadioButton */}

      <h2 className="firm-profile-section-title">Online Scheduling</h2>
      <p className="firm-profile-subtitle">
        Allow potential clients to find and book consultations with you online.
      </p>

      {/* Websites */}
      <div className="firm-profile-group">
        <label className="firm-profile-label">
          Practice website{" "}
          <span className="firm-profile-optional">(optional)</span>
        </label>
        {websites.map((site, idx) => (
          <div key={idx} className="firm-profile-website-row">
            <NarrowInputField
              name={`Website ${idx + 1}`}
              title="Website"
              placeholder="yourfirm.com"
              value={site}
              onChange={(e) => handleWebsiteChange(idx, e.target.value)}
              isRequired={true}
            />
            {idx > 0 && (
              <RemoveCircleOutlineIcon
                style={{ height: "24px", width: "24px", marginBottom: "16px" }}
                className="firm-profile-remove-icon"
                onClick={() => removeWebsite(idx)}
              />
            )}
          </div>
        ))}
        <button className="firm-profile-add-btn" onClick={addWebsite}>
          + Add website
        </button>
      </div>

      {/* Google Booking */}
      <div className="firm-profile-group">
        <label className="firm-profile-label">
          Bookings from Google and others
        </label>
        <p className="firm-profile-note">
          Allow clients to book directly from your Google Business Profile or
          other search engines.{" "}
          <a href="#" className="firm-profile-link">
            Learn more
          </a>
        </p>
        <div className="firm-profile-radio-group">
          <RadioButton
            label="Yes"
            name="googleBooking"
            value="yes"
            checked={googleBooking === "yes"}
            onChange={(e) => setGoogleBooking(e.target.value)}
          />
          <RadioButton
            label="No"
            name="googleBooking"
            value="no"
            checked={googleBooking === "no"}
            onChange={(e) => setGoogleBooking(e.target.value)}
          />
        </div>
      </div>
      <p className="help-text" style={{ marginTop: "100px" }}>
        Need help?
      </p>
    </div>
  );
}
